// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Remove arrow from Add Fluid button */
.button.small::after {
    content: none !important;
}



/* Custom X button styling */
.btn-close-custom {
    position: absolute;
    top: -2px;
    right: -30px;
    width: 30px;
    height: 30px;
    border: 1px solid #FAAB18;
    background-color: white;
    color: #FAAB18;
    font-weight: 50px;
    font-size: 16px;
    border-radius: 4px;
    cursor: pointer;
    padding: 0;
    padding-left: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    font-family: 'GothamNarrowBook';
}

.btn-close-custom::after {
    content: "" !important;
}

.btn-close-custom:hover {
    background-color: #FAAB18;
    color: black;
}

/* Remove arrow from buttons */
.btn-success::after,
.btn-primary::after {
    content: "" !important;
}

/* Add Fluid button styling */
.btn-success {
    background-color: #198754 !important;
    border-color: #198754 !important;
    color: white !important;
    padding: 6px !important;
    padding-left: 10px !important;
    padding-right: 4px !important;
    border-radius: 5px !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    text-transform: none !important;
    font-family: 'GothamNarrowBook' !important;
}

.btn-success:hover {
    background-color: #157347 !important;
    border-color: #146c43 !important;
}

/* Calculate button styling */
.btn-primary {
    background-color: #0d6efd !important;
    border-color: #0d6efd !important;
    color: white !important;
    padding: 6px 16px !important;
    border-radius: 5px !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    text-transform: none !important;
    font-family: 'GothamNarrowBook' !important;
    margin-left: 20px;
    margin-top: 10px;
}

.btn-primary:hover {
    background-color: #0b5ed7 !important;
    border-color: #0a58ca !important;
}

.btn-primary:disabled {
    background-color: #6c757d !important;
    border-color: #6c757d !important;
    opacity: 0.65 !important;
}

/* Ensure card has relative positioning */
.position-relative {
    position: relative;
}

.float-none {
    font-family: 'GothamNarrowBold', sans-serif;
    font-weight: 600;
    color: white !important;
    background-color: #0066b2 !important;
    font-size: 1rem;
    padding: 8px 16px !important;
    margin: 0 !important;
    border-radius: 0.25rem 0.25rem 0 0 !important;
    width: 100% !important;
}

/* Card styling - remove shadow and add border */
.card {
    border: 1px solid rgba(0, 0, 0, 0.125);
    box-shadow: none !important;
    border-radius: 0.5rem;
}

/* Fieldset styling - border color */
fieldset.border {
    border: 1px solid rgba(0, 0, 0, 0.125) !important;
    border-radius: 0.4rem !important;
}

.input-group {
    max-width: 400px;
}

/* Merged input box styling - no gap between input and span */
.input-group .input-group-text {
    background-color: #e9ecef;
    border-left: none;
    border-radius: 0 0.25rem 0.25rem 0 !important;
}

.input-group input {
    border-right: none;
    border-radius: 0.25rem 0 0 0.25rem !important;
}

.col-form-label {
    font-family: 'GothamNarrowBold', sans-serif;
    font-weight: 600;
}
/* Table header styling */
th {
    color: #0b2d71 !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    font-family: 'GothamNarrowBold', sans-serif !important;
}

/* Disabled input styling - gray background */
input:disabled {
    background-color: #e9ecef !important;
    color: #495057 !important;
}

/* Card body padding */.card-body {
    padding: 1.25rem !important;
}

/* Form control spacing */.form-control-sm {
    font-size: 0.875rem !important;
}

/* Empty input validation - red border for inputs with no value */.form-control:invalid,
.form-control:not(:disabled):placeholder-shown {
    border-left: 4px solid #dc3545 !important;
}

/* Valid input - keep normal border when value is present */.form-control:not(:disabled):not(:placeholder-shown) {
    border-left: 1px solid #ced4da !important;
}

/* Override with green border when input-green class is applied */
.form-control.input-green,
.input-group .form-control.input-green {
    border-left: 4px solid #28a745 !important;
}

/* Override with red border when input-red class is applied */
.form-control.input-red,
.input-group .form-control.input-red {
    border-left: 4px solid #dc3545 !important;
}

/* Reading Counts dropdown styling */
select.auto-size {
    width: 100% !important;
    padding: 8px 35px 8px 12px !important;
    font-size: 14px !important;
    border: 1px solid #ced4da !important;
    border-radius: 0.25rem !important;
    background-color: white !important;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e") !important;
    background-repeat: no-repeat !important;
    background-position: right 0.75rem center !important;
    background-size: 16px 12px !important;
    appearance: none !important;
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    font-family: 'GothamNarrowBook' !important;
    cursor: pointer !important;
}

/* Table styling for RPM and READINGS */
.table-borderless {
    border: 1px solid #dee2e6 !important;
    background-color: white !important;
}

.table-borderless th,
.table-borderless td {
    border: none !important;
    padding: 0.5rem !important;
    vertical-align: middle !important;
    background-color: white !important;
}

.table-borderless thead th {
    background-color: white !important;
    border-bottom: 1px solid #dee2e6 !important;
    text-align: left !important;
    padding-left: 1rem !important;
}

.table-borderless tbody {
    background-color: white !important;
}

.table-borderless tbody tr {
    background-color: white !important;
}

.table-borderless td input {
    margin: 0 !important;
    width: 100% !important;
}

/* Graphs Section */
.graphs-section {
    margin-top: 24px;
}

.graphs-header {
    background-color: #0b2d71;
    color: #fff;
    font-weight: 600;
    font-size: 1rem;
    padding: 10px 16px;
    border-radius: 4px 4px 0 0;
    margin-bottom: 16px;
    font-family: 'GothamNarrowBold', sans-serif;
}

/* Rheological Properties Table */
.prop-names {
    width: 260px;
    font-weight: 600;
    color: #0b2d71;
    background-color: #f3f4f8;
}

.prop-values {
    text-align: left;
    font-weight: 600;
    color: #0b2d71;
    background-color: #f3f4f8;
}

fieldset legend {
    color: #0b2d71;
    font-size: 1rem;
    font-weight: 600;
    font-family: 'GothamNarrowBold', sans-serif;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/rheological-hierarchy/hierarchy/hierarchy.component.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;IACI,wBAAwB;AAC5B;;;;AAIA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA,8BAA8B;AAC9B;;IAEI,sBAAsB;AAC1B;;AAEA,6BAA6B;AAC7B;IACI,oCAAoC;IACpC,gCAAgC;IAChC,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA,6BAA6B;AAC7B;IACI,oCAAoC;IACpC,gCAAgC;IAChC,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,0CAA0C;IAC1C,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA,yCAAyC;AACzC;IACI,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;IAC3C,gBAAgB;IAChB,uBAAuB;IACvB,oCAAoC;IACpC,eAAe;IACf,4BAA4B;IAC5B,oBAAoB;IACpB,6CAA6C;IAC7C,sBAAsB;AAC1B;;AAEA,gDAAgD;AAChD;IACI,sCAAsC;IACtC,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA,oCAAoC;AACpC;IACI,iDAAiD;IACjD,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA,6DAA6D;AAC7D;IACI,yBAAyB;IACzB,iBAAiB;IACjB,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI,2CAA2C;IAC3C,gBAAgB;AACpB;AACA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,sDAAsD;AAC1D;;AAEA,6CAA6C;AAC7C;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA,sBAAsB,CAAC;IACnB,2BAA2B;AAC/B;;AAEA,yBAAyB,CAAC;IACtB,8BAA8B;AAClC;;AAEA,iEAAiE,CAAC;;IAE9D,yCAAyC;AAC7C;;AAEA,2DAA2D,CAAC;IACxD,yCAAyC;AAC7C;;AAEA,iEAAiE;AACjE;;IAEI,yCAAyC;AAC7C;;AAEA,6DAA6D;AAC7D;;IAEI,yCAAyC;AAC7C;;AAEA,oCAAoC;AACpC;IACI,sBAAsB;IACtB,qCAAqC;IACrC,0BAA0B;IAC1B,oCAAoC;IACpC,iCAAiC;IACjC,kCAAkC;IAClC,4PAA4P;IAC5P,uCAAuC;IACvC,oDAAoD;IACpD,qCAAqC;IACrC,2BAA2B;IAC3B,mCAAmC;IACnC,gCAAgC;IAChC,0CAA0C;IAC1C,0BAA0B;AAC9B;;AAEA,uCAAuC;AACvC;IACI,oCAAoC;IACpC,kCAAkC;AACtC;;AAEA;;IAEI,uBAAuB;IACvB,0BAA0B;IAC1B,iCAAiC;IACjC,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,2CAA2C;IAC3C,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA,iCAAiC;AACjC;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,2CAA2C;AAC/C","sourcesContent":["/* Remove arrow from Add Fluid button */\n.button.small::after {\n    content: none !important;\n}\n\n\n\n/* Custom X button styling */\n.btn-close-custom {\n    position: absolute;\n    top: -2px;\n    right: -30px;\n    width: 30px;\n    height: 30px;\n    border: 1px solid #FAAB18;\n    background-color: white;\n    color: #FAAB18;\n    font-weight: 50px;\n    font-size: 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    padding: 0;\n    padding-left: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10;\n    font-family: 'GothamNarrowBook';\n}\n\n.btn-close-custom::after {\n    content: \"\" !important;\n}\n\n.btn-close-custom:hover {\n    background-color: #FAAB18;\n    color: black;\n}\n\n/* Remove arrow from buttons */\n.btn-success::after,\n.btn-primary::after {\n    content: \"\" !important;\n}\n\n/* Add Fluid button styling */\n.btn-success {\n    background-color: #198754 !important;\n    border-color: #198754 !important;\n    color: white !important;\n    padding: 6px !important;\n    padding-left: 10px !important;\n    padding-right: 4px !important;\n    border-radius: 5px !important;\n    font-size: 14px !important;\n    font-weight: 500 !important;\n    text-transform: none !important;\n    font-family: 'GothamNarrowBook' !important;\n}\n\n.btn-success:hover {\n    background-color: #157347 !important;\n    border-color: #146c43 !important;\n}\n\n/* Calculate button styling */\n.btn-primary {\n    background-color: #0d6efd !important;\n    border-color: #0d6efd !important;\n    color: white !important;\n    padding: 6px 16px !important;\n    border-radius: 5px !important;\n    font-size: 14px !important;\n    font-weight: 500 !important;\n    text-transform: none !important;\n    font-family: 'GothamNarrowBook' !important;\n    margin-left: 20px;\n    margin-top: 10px;\n}\n\n.btn-primary:hover {\n    background-color: #0b5ed7 !important;\n    border-color: #0a58ca !important;\n}\n\n.btn-primary:disabled {\n    background-color: #6c757d !important;\n    border-color: #6c757d !important;\n    opacity: 0.65 !important;\n}\n\n/* Ensure card has relative positioning */\n.position-relative {\n    position: relative;\n}\n\n.float-none {\n    font-family: 'GothamNarrowBold', sans-serif;\n    font-weight: 600;\n    color: white !important;\n    background-color: #0066b2 !important;\n    font-size: 1rem;\n    padding: 8px 16px !important;\n    margin: 0 !important;\n    border-radius: 0.25rem 0.25rem 0 0 !important;\n    width: 100% !important;\n}\n\n/* Card styling - remove shadow and add border */\n.card {\n    border: 1px solid rgba(0, 0, 0, 0.125);\n    box-shadow: none !important;\n    border-radius: 0.5rem;\n}\n\n/* Fieldset styling - border color */\nfieldset.border {\n    border: 1px solid rgba(0, 0, 0, 0.125) !important;\n    border-radius: 0.4rem !important;\n}\n\n.input-group {\n    max-width: 400px;\n}\n\n/* Merged input box styling - no gap between input and span */\n.input-group .input-group-text {\n    background-color: #e9ecef;\n    border-left: none;\n    border-radius: 0 0.25rem 0.25rem 0 !important;\n}\n\n.input-group input {\n    border-right: none;\n    border-radius: 0.25rem 0 0 0.25rem !important;\n}\n\n.col-form-label {\n    font-family: 'GothamNarrowBold', sans-serif;\n    font-weight: 600;\n}\n/* Table header styling */\nth {\n    color: #0b2d71 !important;\n    font-weight: 600 !important;\n    font-size: 13px !important;\n    font-family: 'GothamNarrowBold', sans-serif !important;\n}\n\n/* Disabled input styling - gray background */\ninput:disabled {\n    background-color: #e9ecef !important;\n    color: #495057 !important;\n}\n\n/* Card body padding */.card-body {\n    padding: 1.25rem !important;\n}\n\n/* Form control spacing */.form-control-sm {\n    font-size: 0.875rem !important;\n}\n\n/* Empty input validation - red border for inputs with no value */.form-control:invalid,\n.form-control:not(:disabled):placeholder-shown {\n    border-left: 4px solid #dc3545 !important;\n}\n\n/* Valid input - keep normal border when value is present */.form-control:not(:disabled):not(:placeholder-shown) {\n    border-left: 1px solid #ced4da !important;\n}\n\n/* Override with green border when input-green class is applied */\n.form-control.input-green,\n.input-group .form-control.input-green {\n    border-left: 4px solid #28a745 !important;\n}\n\n/* Override with red border when input-red class is applied */\n.form-control.input-red,\n.input-group .form-control.input-red {\n    border-left: 4px solid #dc3545 !important;\n}\n\n/* Reading Counts dropdown styling */\nselect.auto-size {\n    width: 100% !important;\n    padding: 8px 35px 8px 12px !important;\n    font-size: 14px !important;\n    border: 1px solid #ced4da !important;\n    border-radius: 0.25rem !important;\n    background-color: white !important;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\") !important;\n    background-repeat: no-repeat !important;\n    background-position: right 0.75rem center !important;\n    background-size: 16px 12px !important;\n    appearance: none !important;\n    -webkit-appearance: none !important;\n    -moz-appearance: none !important;\n    font-family: 'GothamNarrowBook' !important;\n    cursor: pointer !important;\n}\n\n/* Table styling for RPM and READINGS */\n.table-borderless {\n    border: 1px solid #dee2e6 !important;\n    background-color: white !important;\n}\n\n.table-borderless th,\n.table-borderless td {\n    border: none !important;\n    padding: 0.5rem !important;\n    vertical-align: middle !important;\n    background-color: white !important;\n}\n\n.table-borderless thead th {\n    background-color: white !important;\n    border-bottom: 1px solid #dee2e6 !important;\n    text-align: left !important;\n    padding-left: 1rem !important;\n}\n\n.table-borderless tbody {\n    background-color: white !important;\n}\n\n.table-borderless tbody tr {\n    background-color: white !important;\n}\n\n.table-borderless td input {\n    margin: 0 !important;\n    width: 100% !important;\n}\n\n/* Graphs Section */\n.graphs-section {\n    margin-top: 24px;\n}\n\n.graphs-header {\n    background-color: #0b2d71;\n    color: #fff;\n    font-weight: 600;\n    font-size: 1rem;\n    padding: 10px 16px;\n    border-radius: 4px 4px 0 0;\n    margin-bottom: 16px;\n    font-family: 'GothamNarrowBold', sans-serif;\n}\n\n/* Rheological Properties Table */\n.prop-names {\n    width: 260px;\n    font-weight: 600;\n    color: #0b2d71;\n    background-color: #f3f4f8;\n}\n\n.prop-values {\n    text-align: left;\n    font-weight: 600;\n    color: #0b2d71;\n    background-color: #f3f4f8;\n}\n\nfieldset legend {\n    color: #0b2d71;\n    font-size: 1rem;\n    font-weight: 600;\n    font-family: 'GothamNarrowBold', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
